/**
 * Query-param helpers for opening SignupIntentModal from email deep links (?signup=1).
 */
export function shouldOpenSignupIntentFromQuery(
  search: string,
  isAuthenticated: boolean,
  isInitializing: boolean,
): boolean {
  if (isInitializing || isAuthenticated) {
    return false;
  }
  const params = new URLSearchParams(search);
  return params.get('signup') === '1';
}

export function stripSignupQueryFromSearch(search: string): string {
  const params = new URLSearchParams(search);
  if (params.get('signup') !== '1') {
    return search;
  }
  params.delete('signup');
  const remaining = params.toString();
  return remaining ? `?${remaining}` : '';
}
